// Поля формы заявки, которыми можно управлять из админки.
//
// Галочки «мне нужен переводчик» здесь больше нет: у японских туров
// сопровождение входит в программу, и вопрос только сбивал с толку.
// Подробности — в комментарии к request-modal.jsx.
// Используется и общей настройкой («Форма заявки»), и настройкой
// отдельного тура/услуги — чтобы список был в одном месте.
export const REQUEST_FIELDS = [
  {
    key: "phone",
    label: "Телефон",
    hint: "Нужен хотя бы один способ связи — телефон или email.",
  },
  {
    key: "email",
    label: "Email",
    hint: "Нужен хотя бы один способ связи — телефон или email.",
  },
  { key: "people", label: "Количество человек", hint: "" },
  {
    key: "subject",
    label: "Тема заявки",
    hint: "Название тура или услуги. Подставляется само, клиент может поправить.",
  },
  {
    key: "comment",
    label: "Комментарий клиента",
    hint: "Свободное поле: пожелания, даты, вопросы. Виден в разделе «Заявки».",
  },
];
